import React from 'react';

/**
 * Spinning brain icon logo for TravelEase.AI.
 * Uses the extracted transparent brain icon from the original logo.
 * Text uses Inter Black (900) to match the original logo font.
 */
export function SpinningLogo({ size = 'default', className = '' }: { size?: 'default' | 'small' | 'footer'; className?: string }) {
  const iconSize = size === 'small' ? 32 : size === 'footer' ? 36 : 44;
  const textClass = size === 'small'
    ? 'text-lg'
    : size === 'footer'
      ? 'text-xl'
      : 'text-2xl';

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className="spinning-logo-icon" style={{ width: iconSize, height: iconSize }}>
        <img
          src="/logo-icon-only.png"
          alt=""
          width={iconSize}
          height={iconSize}
          draggable={false}
        />
      </div>
      <span className={`tracking-tight ${textClass}`} style={{ fontFamily: "'Inter', sans-serif" }}>
        <span className="text-white" style={{ fontWeight: 300 }}>Travel</span>
        <span className="text-white" style={{ fontWeight: 800 }}>Ease</span>
        <span style={{ color: '#22d3ee', fontWeight: 800 }}>.AI</span>
      </span>
    </div>
  );
}

/**
 * Standalone spinning brain icon used as a page loading indicator.
 */
export function SpinningBrainLoader({ text = 'Laster...' }: { text?: string }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0f14]">
      <div className="flex flex-col items-center gap-4">
        <div className="spinning-logo-icon" style={{ width: 64, height: 64 }}>
          <img
            src="/logo-icon-only.png"
            alt="Loading..."
            width={64}
            height={64}
          />
        </div>
        <p className="text-sm text-muted-foreground">{text}</p>
      </div>
    </div>
  );
}
